import { api } from '@/core/api/';

const URL = 'api/providers/compensatoryrequest';
const formDataHeader = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const search = (payload) =>
  api.get(`${URL}/search`, {
    params: {
      ...payload,
    },
  });

export const searchByContractId = (contractId, payload) =>
  api.get(`${URL}/search/${contractId}`, {
    params: {
      ...payload,
    },
  });
export const getStatusLogByRequestId = (requestId) =>
  api.get(`${URL}/statuslog/${requestId}`);

export const changeRequestStatus = (payload) =>
  api.put(`${URL}/request`, payload);

export const getDocuments = (academicYearId, contractId) => {
  return api.get(`${URL}/documents/${academicYearId}?contractId=${contractId}`);
};

export const getRpDocumentsByRequestId = (academicYearId, requestId) =>
  api.get(`${URL}/rpdocuments/${academicYearId}`, {
    params: { requestId },
  });

export const returnToPreviousStatus = (payload) =>
  api.post(`${URL}/returnToPreviousStatus`, payload);

export const getRpPreviousStatus = (requestCompensatoryId) =>
  api.get(
    `${URL}/statusToReturn?requestCompensatoryId=${requestCompensatoryId}`
  );

export const getCompletePendingApprovalAcceptanceReasons = () =>
  api.get(`${URL}/completependingapprovalacceptancereasons`);

export const getCompletePendingApprovalDenialReasons = () =>
  api.get(`${URL}/completependingapprovaldenialreasons`);

export const getRejectReasons = () =>
  api.get(`${URL}/compensatoryrequestrejectionreasons`);

export const rejectCompensatoryRequest = (payload) =>
  api.post(`${URL}/rejectcompensatoryrequest`, payload, formDataHeader);

export const editInterventions = (payload) =>
  api.post(`${URL}/editinterventionsdue`, payload);

export const saveDocument = (payload) =>
  api.post(`${URL}/savedocument`, payload, formDataHeader);

export const getCompensatoryServiceRequestInfo = (
  compensatoryServiceRequestId
) =>
  api.get(`${URL}/compensatoryServiceRequest/${compensatoryServiceRequestId}`);

export const getCompensatoryServiceInterventions = (
  compensatoryServiceRequestId
) =>
  api.get(
    `${URL}/compensatoryserviceinterventions/${compensatoryServiceRequestId}`
  );

export const getCompensatoryRepositionAbsence = () =>
  api.get(`${URL}/compensatoryrepositionabsence`);

export const getRequestDocumentsByRequestId = (academicYearId, requestId) =>
  api.get(`${URL}/documents/${academicYearId}`, {
    params: { requestId },
  });
